import React, { useState, useRef, useEffect } from 'react';
import { RenderInWindow } from '../render-in-window';
export const LoginModal = ({ authUrl, httpClient }) => {
    const [showWindowPortal, setShowWindowPortal] = useState(false);
    const [url, setUrl] = useState('');
    // const [configurationId, setConfigurationId] = useState('');
    const newWindow = useRef(null);
    useEffect(() => {
        if (url)
            setShowWindowPortal(true);
    }, [url]);
    useEffect(() => {
        if (newWindow.current) {
            setShowWindowPortal(false);
        }
    }, [setShowWindowPortal]);
    useEffect(() => {
        const handleOpen = async (event) => {
            const configId = event.detail;
            setShowWindowPortal(false);
            try {
                const redirectUrl = encodeURIComponent(`${window.location.origin}/close?from=${configId}`);
                const response = await httpClient(`${authUrl}/auth/link/${configId}?useTenantStore=false&propagateSecretsToClient=false&redirectUrl=${redirectUrl}`);
                const { url } = response;
                setUrl(url);
            }
            catch (err) {
                console.log(err);
            }
        };
        window.addEventListener('open-auth-modal', handleOpen);
        return () => window.removeEventListener('open-auth-modal', handleOpen);
    }, []);
    return showWindowPortal ? React.createElement(RenderInWindow, { url: url }) : null;
};
